import { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";

export const ACTIVE = ["queued", "running"];

/** State + polling for Settings → "Retention window (all sites)". */
export function useRetentionApply(status, onDone) {
  const [hot, setHot] = useState(status?.defaults?.hot_days ?? 14);
  const [archive, setArchive] = useState(status?.defaults?.archive_days ?? 14);
  const [plan, setPlan] = useState(null);
  const [job, setJob] = useState(null);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const timer = useRef(null);
  useEffect(() => () => clearInterval(timer.current), []);

  function poll(id) {
    clearInterval(timer.current);
    timer.current = setInterval(async () => {
      try {
        const r = await api.get(`/admin/lifecycle/jobs/${id}`);
        setJob(r.data);
        if (!ACTIVE.includes(r.data.status)) { clearInterval(timer.current); onDone && onDone(r.data); }
      } catch (e) { clearInterval(timer.current); setErr(e.response?.data?.detail || e.message); }
    }, 2000);
  }

  async function call(dryRun) {
    setBusy(true); setErr("");
    try {
      const r = await api.post("/admin/lifecycle/retention/apply", { hot_days: hot, archive_days: archive, run_now: true, dry_run: dryRun });
      if (dryRun) { setJob(null); setPlan(r.data); return; }
      setPlan(null); setJob({ id: r.data.job_id, status: "queued", stage: "queued", started_at: new Date().toISOString() }); poll(r.data.job_id);
    } catch (e) { setErr(e.response?.data?.detail || e.message); }
    finally { setBusy(false); }
  }

  const setDays = (setter) => (v) => { setter(parseInt(v) || 1); setPlan(null); };
  return {
    hot, archive, setHot: setDays(setHot), setArchive: setDays(setArchive), plan, job, busy, err,
    active: ACTIVE.includes(job?.status), preview: () => call(true), run: () => call(false), cancelPlan: () => setPlan(null),
  };
}
